// extracted by mini-css-extract-plugin
export default {"button":"button_button__-o8Pu","l":"button_l__sgzwu","m":"button_m__Tt43r","primary":"button_primary__+Z8Ck","secondary":"button_secondary__iqdz0"};